import React, { useEffect } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import TopPageButton from "../Components/TopPage/TopePage";
import ServicesPage from "../Components/Services/ServicesPage";
import { Helmet } from "react-helmet-async";

const Services = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Services | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="Here are all the services which I provide to you. You can see all the details regarding to me services individually also."
        />
        <meta
          name="keywords"
          content="Aneeq Ullah Khan, Aneeq Ullah Khan Services, Services Aneeq Ullah Khan, Aneeq Khan Services"
        />
      </Helmet>
      <Navbar />
      <div className="mainDiv">
        <p className="heading-text text-center">Services</p>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 160">
          <path
            fill="#0d1117"
            fill-opacity="1"
            d="M0,64L80,80C160,96,320,128,480,128C640,128,800,96,960,85.3C1120,75,1280,85,1360,90.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className="container mt-4 mb-4">
        <ServicesPage />
      </div>

      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default Services;
